// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"f2a7dbb8","651":"3f205cb0"}[chunkId] + ".chunk.js";
};